const stateChecker = checker => {
    return (props, propName, ...rest) => {
        return checker(props[propName], props.id, ...rest);
    };
};

export default stateChecker;
